export enum FilterTypes {
	STATUS = 0,
	ORDER = 1,
	SEARCH = 2,
	TRAIT = 3,
	PRICE = 4,
	RARITY = 5,
	COLLECTION = 6,
}
